module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-12.2c3b954e.png";